import {createAction} from 'redux-actions'
import {
  GET_AVAILABLE_CREDENTIALS,
  GET_AUTH_PUBLIC_KEYS,
  X_GET_EMAIL_TYPE,
  GET_2FA,
  AUX_GET_LOGIN_PUBLIC_KEYS
} from '@rambler-id/transport'
import {apiV3} from 'utils/transport'
import randomString from 'random-string'
import {sentryReact as Sentry} from '@rambler-id/sentry'
import {throwError} from 'containers/App/actions'
import {selectBlockedRamblerMail, selectEmails} from './selectors'
import * as blockStatusActions from './blockStatusActions'

export const updateUser = createAction('UPDATE_USER')
export const updateMailAction = createAction('UPDATE_MAIL_ACTION')
export const updateSecretQuestion = createAction('UPDATE_SECRET_QUESTION')
export const updateRamblerMailPhone = createAction('UPDATE_RAMBLER_MAIL_PHONE')
export const updateProfile = createAction('UPDATE_PROFILE')
export const updateDisplayName = createAction('UPDATE_DISPLAY_NAME')
export const addAccount = createAction('ADD_ACCOUNT')
export const addContact = createAction('ADD_CONTACT')
export const confirmContact = createAction('CONFIRM_CONTACT')
export const cancelContact = createAction('CANCEL_CONTACT')
export const cancelSocialProfile = createAction('CANCEL_SOCIAL_PROFILE')
export const updateDefaultChampionat = createAction('UPDATE_DEFAULT_CHAMPIONAT')
export const addWebAuthnKey = createAction('ADD_WEB_AUTHN_KEY')
export const deleteWebAuthnKey = createAction('DELETE_WEB_AUTHN_KEY')
export const updateEmailCredentials = createAction('UPDATE_EMAIL_CREDENTIALS')
export const updateIs2faEnabled = createAction('UPDATE_IS_2FA_ENABLED')
export const updateAccounts = createAction('UPDATE_ACCOUNTS')

export const getUserAccountsInfo = () => async (dispatch) => {
  try {
    return apiV3('/profile/getInfo', {
      getContacts: 1,
      getAccounts: 1
    })
  } catch (error) {
    if (error.code === 0 || error.code === -17) {
      dispatch(
        throwError(
          'По техническим причинам отображены не все данные. При необходимости перезагрузите страницу.',
          error
        )
      )
    } else {
      Sentry.captureException(error)
    }

    return {}
  }
}

export const loadUser = () => async (dispatch, getState) => {
  let profile = null

  try {
    const response = await apiV3('/profile/getInfo', {
      getAccounts: 1,
      getChampionat: 1,
      getContacts: 1,
      getSocialProfiles: 1,
      getChainId: 1,
      getSessionInfo: 1,
      encAvatarUrlNonce: randomString({
        length: 17,
        special: false
      }).toLowerCase()
    })

    profile = response.profile

    const {availableCreds} = await apiV3(
      `/legacy/${GET_AVAILABLE_CREDENTIALS}`,
      {}
    )
    const problematicCreds = availableCreds.filter(
      ({status}) => status !== 'OK'
    )

    profile.info.problematicCreds = problematicCreds
    profile.info.emailCredentials = null

    try {
      let [{authPublicKeys}, {loginPublicKeys}] = await Promise.all([
        apiV3(`/legacy/${GET_AUTH_PUBLIC_KEYS}`, {}),
        apiV3(`/legacy/${AUX_GET_LOGIN_PUBLIC_KEYS}`, {})
      ])

      loginPublicKeys = loginPublicKeys.map((item) => ({...item, type: 'pls'}))

      authPublicKeys = authPublicKeys.map((item) => ({
        ...item,
        type: 'webauthn'
      }))

      profile.info.webAuthnKeys = [...authPublicKeys, ...loginPublicKeys]
    } catch (error) {
      if (error.code === -10) {
        profile.info.webAuthnKeys = []
      } else {
        throw error
      }
    }

    dispatch(updateUser(profile))

    const emails = selectEmails(getState())

    const blockedRamblerMail = selectBlockedRamblerMail(getState())

    let emailCredentials = [
      ...(profile.type === 'general'
        ? !blockedRamblerMail.status
          ? [profile.info.email]
          : []
        : []),
      ...emails.filter(({status}) => !status).map(({accountId}) => accountId)
    ]

    emailCredentials = await Promise.all(
      emailCredentials.map(async (email) => {
        const emailType = await apiV3(`/legacy/${X_GET_EMAIL_TYPE}`, {email})
        let creds = {
          ...(emailType.result.type === 'rambler'
            ? {
                account: email,
                type: 'rambler-mail',
                subtype: 'login'
              }
            : {
                account: email.replace('@', '#'),
                type: 'x-account',
                subtype: 'passport.rambler.ru'
              })
        }
        const result = await apiV3(`/legacy/${GET_2FA}`, {...creds})

        creds.is2faEnabled = result['2faEnabled'] === 1

        return creds
      })
    )

    dispatch(updateEmailCredentials(emailCredentials))
  } catch (error) {
    if (error.code === 0 || error.code === -17 || profile) {
      dispatch(
        throwError(
          'По техническим причинам отображены не все данные. При необходимости перезагрузите страницу.',
          error
        )
      )
    } else {
      Sentry.captureException(error)
    }

    dispatch(updateUser(profile))
    dispatch(updateEmailCredentials([]))
  }

  if (!profile || profile.type !== 'general') {
    return
  }

  const blockedRamblerMail = selectBlockedRamblerMail(getState())

  let ramblerMailAction =
    blockedRamblerMail.status !== undefined
      ? blockStatusActions[blockedRamblerMail.status]
      : null

  dispatch(updateMailAction(ramblerMailAction))
}
